
 export const PintrestJson = [
  {
    "id": "featured_001",
    "previewURL": "/PintrestImage/standing-woman001.jpg",
    "webformatURL": "/PintrestImage/standing-woman001.jpg",
    "largeImageURL": "/PintrestImage/standing-woman001.jpg",

    "previewWidth": 300,
    "previewHeight": 450,

    "imageWidth": 1080,
    "imageHeight": 1620,

    "tags": "ocean sunset aesthetic",
    "pageURL": "woman fashion outfit aesthetic",

    "_source": "pintrest",

    "_category": "woman",

    "_uid": "featured_001"
  },

  {
    "id": "featured_002",
    "previewURL": "/PintrestImage/standing-woman002.jpg",
    "webformatURL": "/PintrestImage/standing-woman002.jpg",
    "largeImageURL": "/PintrestImage/standing-woman002.jpg",

    "previewWidth": 300,
    "previewHeight": 450,

    "imageWidth": 1080,
    "imageHeight": 1620,

    "tags": "woman, standing-woman,  model",
    "pageURL": "minimal-woman-fashion",

    "_source": "pintrest",

    "_category": "woman",

    "_uid": "featured_002"
  },
  {
    id: "featured_003",

    previewURL: "/PintrestImage/ocean-sunset001.jpg",
    webformatURL: "/PintrestImage/ocean-sunset001.jpg",
    largeImageURL: "/PintrestImage/ocean-sunset001.jpg",

    previewWidth: 300,
    previewHeight: 450,

    imageWidth: 1080,
    imageHeight: 1620,

    tags: "ocean beach waves shoreline sunset aesthetic",

    pageURL: "ocean-beach-waves-sunset",

    _source: "pintrest",

    _category: "ocean beach sunset waves sea",

    _uid: "featured_003"
  },
  {
    id: "featured_004",

    previewURL: "/PintrestImage/ocean-sunset002.jpg",
    webformatURL: "/PintrestImage/ocean-sunset002.jpg",
    largeImageURL: "/PintrestImage/ocean-sunset002.jpg",

    previewWidth: 300,
    previewHeight: 450,

    imageWidth: 1080,
    imageHeight: 1620,

    tags: "ocean sunset golden hour sea horizon aesthetic",

    pageURL: "ocean-sunset-golden-hour",

    _source: "pintrest",

    _category: "ocean beach sunset waves sea",

    _uid: "featured_004"
  },
  {
    id: "featured_005",

    previewURL: "/PintrestImage/ocean-sunset003.jpg",
    webformatURL: "/PintrestImage/ocean-sunset003.jpg",
    largeImageURL: "/PintrestImage/ocean-sunset003.jpg",

    previewWidth: 300,
    previewHeight: 450,

    imageWidth: 1080,
    imageHeight: 1620,

    tags: "ocean beach sunset waves shoreline golden hour peaceful aesthetic",

    pageURL: "ocean-beach-sunset-waves",

    _source: "pintrest",

    _category: "ocean beach sunset waves sea",

    _uid: "featured_005"
  },
  {
  id: "featured_006",

  previewURL: "/PintrestImage/ocean-sunset004.jpg",
  webformatURL: "/PintrestImage/ocean-sunset004.jpg",
  largeImageURL: "/PintrestImage/ocean-sunset004.jpg",

  previewWidth: 300,
  previewHeight: 450,

  imageWidth: 1080,
  imageHeight: 1620,

  tags:  "pink sunset, purple sky, ocean, calm sea, pastel sky, horizon, beach, peaceful, evening, aesthetic",

  pageURL: "pink-ocean-sunset-pastel-sky",

  _source: "pintrest",

  _category: "ocean beach sunset sea sky pink purple pastel horizon",

  _uid: "featured_006"
},
 {
  id: "featured_007",

  previewURL: "/PintrestImage/ocean-sunset005.jpg",
  webformatURL: "/PintrestImage/ocean-sunset005.jpg",
  largeImageURL: "/PintrestImage/ocean-sunset005.jpg",

  previewWidth: 300,
  previewHeight: 450,

  imageWidth: 1080,
  imageHeight: 1620,

  tags: "heart clouds, ocean sunset, golden sunset, beach waves, romantic sky, orange clouds, sea horizon, sunset reflection, dreamy beach, aesthetic",

  pageURL: "heart-clouds-ocean-sunset",

  _source: "pintrest",

  _category: "ocean beach sunset sea waves heart clouds golden sky romantic",

  _uid: "featured_007"
},

]